import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  originalPrice: number;
  salePrice: number;
  currency?: string;
}
export function PriceDisplay({
  originalPrice,
  salePrice,
  currency = 'ARS'
}: PriceDisplayProps) {
  const [currencySymbol, setCurrencySymbol] = useState('$');
  useEffect(() => {
    const locale = navigator.language || 'es-AR';
    // Map locale to currency symbol
    const symbolMap: {
      [key: string]: string;
    } = {
      'en-US': '$',
      'en-GB': '£',
      'es-ES': '€',
      'es-AR': '$',
      'es-MX': '$',
      'pt-BR': 'R$'
    };
    // Get symbol based on locale or default to $
    const symbol = symbolMap[locale] || symbolMap[locale.split('-')[0]] || '$';
    setCurrencySymbol(symbol);
  }, []);
  const formatPrice = (price: number) => {
    return price.toLocaleString('es-AR');
  };
  return <div className="text-center" data-id="element-63">
      <div className="mb-2" data-id="element-64">
        <span className="font-heading text-2xl md:text-3xl text-gray-500 line-through" data-id="element-65">
          {currencySymbol}
          {formatPrice(originalPrice)} {currency}
        </span>
      </div>
      <div className="flex items-center justify-center gap-2" data-id="element-66">
        <span className="font-heading font-bold text-5xl md:text-6xl text-primary" data-id="element-67">
          {currencySymbol}
          {formatPrice(salePrice)}
        </span>
        <div className="flex flex-col items-start" data-id="element-68">
          <span className="font-body text-lg text-gray-700" data-id="element-69">{currency}</span>
          <span className="font-heading font-bold text-sm text-urgency bg-urgency/10 px-2 py-1 rounded" data-id="element-70">
            OFERTA
          </span>
        </div>
      </div>
    </div>;
}